import App from '@/components/App';
import CheckoutOrderedFor from '@/components/checkout/OrderedFor';
import OrderComplete from '@/components/OrderComplete';
import Modal from '@/components/ui/Modal';
import Icon from '@/components/ui/Icon';
import DateTime from '../../../js/components/date-time';

export default {
    App,
    CheckoutOrderedFor,
    DateTime,
    Modal,
    Icon,
    OrderComplete,
};
